import { Spin } from "antd";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "./AuthContext";

/** Serve una sessione; con `admin` anche il permesso admin (admin di portale; altrimenti torna alla home del portale). */
export function Protected({ admin, children }: { admin?: boolean; children: React.ReactNode }) {
  const { me, loading } = useAuth();
  const loc = useLocation();
  if (loading) return <Spin style={{ display: "block", margin: "20vh auto" }} />;
  if (!me) return <Navigate to={`/login?from=${encodeURIComponent(loc.pathname + loc.search)}`} replace />;
  if (admin && !me.azioni.includes("admin")) return <Navigate to="/" replace />;
  return <>{children}</>;
}
